module.exports = __webpack_public_path__ + "static/media/groups-upper-banner.f6856a36.png";